module.exports = __webpack_public_path__ + "loader.341000eb4ad29053e65d.gif";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/loader.gif
// module id = ../../../../../src/assets/img/loader.gif
// module chunks = main